<aside class="left-sidebar sidebar-dark" id="left-sidebar"
  style="background-image:url('/assets/img/sidebar/sidebar-bg-05.jpg'); background-size: cover; background-position: center;">
  <div id="sidebar" class="sidebar sidebar-with-footer">
    <!-- Application Brand -->
    <div class="app-brand">
      @if (isInArchiveMode) {
        <div class="app-brand-archief">
          <i class="fas fa-history"></i><span>{{ 'T4.PAGE-HEADER.ARCHIVE' | translate }}</span>
        </div>
      }
      @if (!isInArchiveMode) {
        <ng-template t4Inject></ng-template>
      }
    </div>

    <!-- begin sidebar scrollbar -->
    <div class="sidebar-scrollbar" id="sidebar-scrollbar">

      <!-- sidebar menu -->

      <ul class="nav sidebar-inner" id="sidebar-menu">

        @for (item of menuItems; track item) {
          <li (click)="setExpanded(item.cleanState)"
            [class.expand]="item.cleanState === expandedMnuName && expandedMnuState"
            [class.has-sub]="item.SubItems && item.SubItems.length > 0" [class.section-title]="item.Type==='subHeader'"
            routerLinkActive="active">
            @switch (item.Type) {
              @case ('link') {
                <a class="sidenav-item-link" routerLink="/{{item.State}}" [attr.data-testid]="'sidenav-' + item.State">
                  <i class="{{item.Icon}}" [style.font-size]="isLargeMenuIcon(item) ? '20px' : null"></i>
                  <span>{{item.Name | translate}}</span>
                </a>
              }
              @case ('subHeader') {
                <span >{{item.Name | translate}}</span>
              }
              @default {
                <a class="sidenav-item-link clickable" role="button" data-bs-toggle="collapse"
                  [attr.aria-expanded]="item.cleanState === expandedMnuName && expandedMnuState ? 'true' : 'false'"
                  [attr.data-testid]="'sidenav-' + item.cleanState"
                  >
                  <i class="{{item.Icon}}" [style.font-size]="isLargeMenuIcon(item) ? '20px' : null"></i>
                  <span class="nav-text">{{item.Name | translate}}</span>
                  @if (item.SubItems && item.SubItems.length > 0) {
                    <b class="caret"></b>
                  }
                </a>
              }
            }
            @if (item.SubItems && item.SubItems.length > 0) {
              <ul class="collapser" [class.showed]="item.cleanState === expandedMnuName && expandedMnuState" data-parent="#sidebar-menu">
                <div class="sub-menu">
                  @for (subItem of item.SubItems; track subItem) {
                    @if (subItem.Type ==='subHeader') {
                      <li class="section-title">
                        <div class="section-title-text">{{subItem.Name | translate}}</div>
                      </li>
                      @for (subSubItem of subItem.SubItems; track subSubItem) {
                        <li
                          routerLinkActive="active"
                          [class.has-sub]="subSubItem.SubItems && subSubItem.SubItems.length > 0">
                          <a class="sidenav-item-link"
                            routerLink="{{item.State ? '/'+item.State : ''}}/{{subItem.State ? '/'+subItem.State : ''}}/{{subSubItem.State}}"
                            [attr.data-testid]="'sidenav-' + subSubItem.State">
                            <span class="nav-text">{{subSubItem.Name | translate}}</span>
                          </a>
                        </li>
                      }
                    } @else {
                      <li routerLinkActive="active">
                        <a class="sidenav-item-link" routerLink="{{item.State ? '/'+item.State : ''}}/{{subItem.State}}" [attr.data-testid]="'sidenav-' + subItem.State">
                          <span class="nav-text">{{subItem.Name | translate}}</span>
                        </a>
                      </li>
                    }
                  }
                </div>
              </ul>
            }
          </li>
        }

      </ul>

    </div>
    <!-- <div class="sidebar-footer">
    <div class="sidebar-footer-content">
      <ul class="d-flex">
        <li>
          <a href="user-account-settings.html" data-bs-toggle="tooltip" title="Profile settings"><i
          class="mdi mdi-settings"></i></a></li>
          <li>
            <a href="#" data-bs-toggle="tooltip" title="No chat messages"><i class="mdi mdi-chat-processing"></i></a>
          </li>
        </ul>
      </div>
    </div> -->
  </div>
</aside>
